import React, { useEffect, useState } from 'react';

import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

import { useContext as useUsersContext } from 'components/Users/Context';

import routes from 'app/routes';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

// RESOURCES
import Resources from 'components/Members/Resources/Index';

// PROGRAMS
import { ContextProvider as ProgramContext } from 'components/Members/Programs/Views/Show/Context';
import SessionSchedule from 'components/Members/Schedule/Views/New/Index';
import SessionSummary from 'components/Members/Schedule/Views/Summary/Index';
import TalentAssessments from 'components/Members/TalentAssessment/Views/New/Index';
import TalentAssessmentsShow from 'components/Members/TalentAssessment/Views/Show/Index';
import GrowthReportShow from 'components/Members/GrowthReport/Views/Show/Index';
import BuyOrSkip from 'components/Members/Schedule/Views/BuyOrSkip/Index';
import EditTimeZone from 'components/Members/Profile/MemberInfo/Edit/TimeZone';
import WebView from 'components/WebView/Index';
import ProgramsList from 'components/Members/Programs/Views/List/Index';
import ProgramsShow from 'components/Members/Programs/Views/Show/Index';
import ProgramsShare from 'components/Members/Programs/Views/Show/Share/Index';

import NewChooseType from 'components/Members/Programs/Views/New/ChooseNewProgramType/Index';

import SelectCoach from 'components/Members/Programs/Views/New/SelectCoach/Index';
import NewProgram from 'components/Members/Programs/Views/New/Index';
import LearningStyle from 'components/Members/Programs/Views/New/LearningStyle/Index';
import MyPreferences from 'components/Members/Programs/Views/New/MyPreferences/Index';
import OrderTopics from 'components/Members/Programs/Views/New/OrderTopics/Index';
import Confirm from 'components/Members/Programs/Views/New/Confirm/Index';
import CoachFeedback from 'components/Members/Programs/Views/CoachFeedback/Index';
import ProgramFeedback from 'components/Members/Programs/Views/ProgramFeedback/Index';

import ProgramsChangeTopic from 'components/Members/Programs/Views/Show/ChangeTopic/Index';
import ProgramsChangeCoach from 'components/Members/Programs/Views/Show/ChangeCoach/Index';
import ChooseNewCoach from 'components/Members/Programs/Views/ChooseNewCoach/Index';

import AiGoals from 'components/Members/Programs/Views/NewAi/Goals/Index';
import PrepareProgram from 'components/Members/Programs/Views/NewAi/BuildProgram/Index';

import NewProgramTalentAssessment from 'components/Members/Programs/Views/New/TalentAssessment/Index';
import NewProgramTalentAssessmentShow from 'components/Members/Programs/Views/New/TalentAssessmentShow/Index';

import AiConfirm from 'components/Members/Programs/Views/NewAi/Confirm/Index';
import AiOrderTopics from 'components/Members/Programs/Views/NewAi/OrderTopics/Index';
import NewAiProgram from 'components/Members/Programs/Views/NewAi/Index';

// CHATS
import useChats from 'components/Common/Chats/Hooks/useChats';
import ChatMain from 'components/Members/Chats/Main';
import ChatMessages from 'components/Members/Chats/Messages';

// SCHEDULE
import ScheduleList from 'components/Members/Schedule/Views/List/Index';
import ZoomInfo from 'components/Members/Schedule/Views/ZoomInfo/Index';

// ASSESSMENT
import AssessmentIndex from 'components/Members/Assessments/Index';

// WALLET
import Wallet from 'components/Members/Wallet/Main';

// SETTINGS
import SettingsMain from 'components/Members/Settings/Main';

import UpdatePassword from 'components/Members/Settings/UpdatePassword';
import UpdateEmail from 'components/Members/Settings/UpdateEmail';

import ErrorBoundary from 'components/new_ui/Errors/ErrorBoundary';
import StepContent from 'components/Members/Programs/Views/Show/StepResources/Index';
import Cards from './Cards';

export default function Index() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: userState } = useUsersContext();

  const [refreshKey, setRefreshKey] = useState(0);
  const [refreshKeySchedule, setRefreshKeySchedule] = useState(0);
  const { chats, updateCountUnreadMessage } = useChats();

  const refreshParent = () => {
    setRefreshKey((prevKey) => prevKey + 1);
  };

  const refreshParentSchedule = () => {
    setRefreshKeySchedule((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  useEffect(() => {
    if (chats) {
      const counter = document.querySelector('#menu .unread-messages');

      if (counter) {
        const unreadMessages = chats.map((chat) => chat.attributes.unread).reduce((acc, val) => acc + val, 0);

        counter.innerHTML = unreadMessages > 0 ? `<span>${unreadMessages}</span>` : '';
      }
    }
  }, [chats]);

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/members/home" element={<Cards />} errorElement={<ErrorBoundary />} />
        <Route path="/members/resources" element={<Resources />} errorElement={<ErrorBoundary />} />
        <Route path="/members/programs" element={<ProgramsList />} errorElement={<ErrorBoundary />} />
        <Route
          path={routes.members.programs.show()}
          element={<ProgramContext><ProgramsShow key={refreshKey} /></ProgramContext>}
          errorElement={<ErrorBoundary />}
        >
          <Route path={routes.members.programs.program.share} element={<ProgramsShare />} />
          <Route path={routes.members.programs.program.step.changeTopic()} element={<ProgramsChangeTopic />} />
          <Route path={routes.members.programs.program.changeCoach} element={<ProgramsChangeCoach />} />
          <Route
            path={routes.members.programs.program.step.buyOrSkip()}
            element={<BuyOrSkip refreshParent={refreshParent} />}
          />
        </Route>
        <Route path={routes.members.programs.chooseType} element={<NewChooseType />} errorElement={<ErrorBoundary />} />
        <Route
          path={routes.members.programs.new.index}
          element={<ProgramContext><NewProgram /></ProgramContext>}
          errorElement={<ErrorBoundary />}
        >
          <Route path={routes.members.programs.new.orderTopics()} element={<OrderTopics />}>
            <Route path={routes.members.programs.new.setTopic()} element={<ProgramsChangeTopic />} />
          </Route>
          <Route path={routes.members.programs.new.talentAssessment()} element={<NewProgramTalentAssessment />} />
          <Route
            path={routes.members.programs.new.talentAssessmentShow()}
            element={<NewProgramTalentAssessmentShow />}
          />
          <Route path={routes.members.programs.new.learningStyle()} element={<LearningStyle />} />
          <Route path={routes.members.programs.new.myPreferences()} element={<MyPreferences />} />
          <Route path={routes.members.programs.new.selectCoach()} element={<SelectCoach />} />
          <Route path={routes.members.programs.new.confirm()} element={<Confirm />} />
          <Route path={routes.members.programs.new.webview} element={<WebView />} />
        </Route>
        <Route
          path={routes.members.programs.new_ai.index}
          element={<ProgramContext><NewAiProgram /></ProgramContext>}
          errorElement={<ErrorBoundary />}
        >
          <Route path={routes.members.programs.new_ai.goals} element={<AiGoals />} />
          <Route path={routes.members.programs.new_ai.prepareProgram} element={<PrepareProgram />} />
          <Route path={routes.members.programs.new_ai.orderTopics()} element={<AiOrderTopics />}>
            <Route path={routes.members.programs.new_ai.setTopic()} element={<ProgramsChangeTopic />} />
          </Route>
          <Route path={routes.members.programs.new_ai.confirm()} element={<AiConfirm />} />
          <Route path={routes.members.programs.new_ai.webview} element={<WebView />} />
        </Route>
        <Route
          path={routes.members.programs.chooseNewCoach()}
          element={<ChooseNewCoach />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.programs.coachFeedback()}
          element={<CoachFeedback />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.programs.programFeedback()}
          element={<ProgramFeedback />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.programs.talentAssessments()}
          element={<TalentAssessments />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.programs.talentAssessmentsShow()}
          element={<TalentAssessmentsShow />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.programs.growthReportShow()}
          element={<GrowthReportShow />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.steps.schedule()}
          element={<SessionSchedule />}
          errorElement={<ErrorBoundary />}
        >
          <Route path={routes.members.steps.timezone()} element={<EditTimeZone refreshParent={refreshParent} />} />
          <Route
            path={routes.members.steps.buyOrSkipSchedule()}
            element={<BuyOrSkip refreshParent={refreshParent} />}
          />
        </Route>
        <Route
          path={routes.members.steps.scheduleSummary()}
          element={<SessionSummary />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.steps.content()}
          element={<StepContent />}
          errorElement={<ErrorBoundary />}
        />
        <Route
          path={routes.members.webview.finish}
          element={<WebView />}
          errorElement={<ErrorBoundary />}
        />

        <Route
          path={routes.members.chats.index}
          element={<ChatMain chats={chats} />}
          errorElement={<ErrorBoundary />}
        >
          <Route
            path={routes.members.chats.messages()}
            element={<ChatMessages updateCountUnreadMessage={updateCountUnreadMessage} />}
          />
        </Route>

        <Route
          path={routes.members.schedule.index}
          element={<ScheduleList key={refreshKeySchedule} />}
          errorElement={<ErrorBoundary />}
        >
          <Route
            path={routes.members.steps.buyOrSkip()}
            element={<BuyOrSkip key="list-skip" refreshParent={refreshParentSchedule} />}
          />
          <Route path={routes.members.steps.zoomInfo()} element={<ZoomInfo />} />
        </Route>

        <Route
          path={routes.members.steps.schedule()}
          element={<SessionSchedule key={refreshKeySchedule} />}
          errorElement={<ErrorBoundary />}
        >
          <Route
            path={routes.members.steps.timezone()}
            element={<EditTimeZone refreshParent={refreshParentSchedule} />}
          />
          <Route path={routes.members.steps.buyOrSkipSchedule()} element={<BuyOrSkip key="session-skip" />} />
        </Route>

        <Route
          path={routes.members.steps.scheduleSummary()}
          element={<SessionSummary />}
          errorElement={<ErrorBoundary />}
        />

        <Route
          path="/members/assessments"
          element={<AssessmentIndex />}
          errorElement={<ErrorBoundary />}
        />

        <Route
          path="/members/wallet"
          element={<Wallet />}
          errorElement={<ErrorBoundary />}
        />

        <Route
          path={routes.members.settings.index}
          element={<SettingsMain />}
          errorElement={<ErrorBoundary />}
        >
          <Route path={routes.members.settings.passwordUpdate} element={<UpdatePassword />} />
          <Route path={routes.members.settings.emailUpdate} element={<UpdateEmail />} />
        </Route>

      </>,
    ),
  );

  if (userState.user === null) {
    return (
      <div className="content pt-5 pb-5">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return (
    <RouterProvider router={router} />
  );
}
